import { useSelector } from 'react-redux';
import { State } from 'src/redux/types';
import { alertItem, incidentItem } from '../types';

export const useAlertsList = (): [
  (alertItem & { id: string })[],
  boolean | undefined
] => {
  const { data, loading } = useSelector(
    (state: State) => state.alerts.alertsList
  );
  const firstItem = Array.isArray(data) ? data[0] : data;

  const oServiceNowAlertsResponse: (alertItem & { id: string })[] = (
    firstItem?.oServiceNowAlertsResponse || []
  ).map((item, idx) => ({
    ...item,
    id: item.number || `${idx}`,
  }));

  return [oServiceNowAlertsResponse, loading];
};

export const useIncidentsList = (): [
  (incidentItem & { id: string })[],
  boolean | undefined
] => {
  const { data, loading } = useSelector(
    (state: State) => state.alerts.alertsList
  );
  const firstItem = Array.isArray(data) ? data[0] : data;

  const oServiceNowIncidentsResponse: (incidentItem & { id: string })[] = (
    firstItem?.oServiceNowIncidentsResponse || []
  ).map((item, idx) => ({
    ...item,
    id: item.number || `${idx}`,
  }));

  return [oServiceNowIncidentsResponse, loading];
};
